const state = {
    snack: {
        message: '',
        color: '',
        timeout: -1,
    },
};

const getters = {
    getSnackbar: (state) => {
        return state.snack;
    },
};

const mutations = {
    SET_SNACK(state, snackBar) {
        state.snack = snackBar;
    },
};

export default {
    namespaced: true,
    state,
    mutations,
    getters,
};
